import { makeStyles } from '@material-ui/core/styles'
import React from 'react'

import Divider from '../atom/Divider'
import Box from '../base/Box'
import { SwipeableDrawer } from '../base/SwipeableDrawer'
import Typography from '../base/Typography'

export type BottomDrawerProps = {
  title?: string
  children: React.ReactNode
  open?: boolean
  onOpen: React.ReactEventHandler
  onClose: React.ReactEventHandler
  style?: React.CSSProperties
}

const useStyles = makeStyles({
  root: {
    padding: '16px',
    backgroundColor: 'white',
    borderRadius: '16px 16px 0px 0px'
  },
  divider: {
    maxWidth: '42px',
    height: '4px',
    backgroundColor: '#7A98AA',
    margin: 'auto',
    marginBottom: '24px'
  }
})

export const BottomDrawer: React.FC<BottomDrawerProps> = (props) => {
  const { title, open = false, style, onOpen, onClose, children } = props
  const classes = useStyles()

  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      onOpen={onOpen}
      classes={{ paper: classes.root }}
      style={style}
    >
      <Box>
        <Divider className={classes.divider} />
        {title && <Typography>{title}</Typography>}
        {children}
      </Box>
    </SwipeableDrawer>
  )
}

export default BottomDrawer